export enum FolderTrackingStepVisibilityCondition {
    Always,
    Never,
    OnlyIfActivated,
    OnlyIfNotInStates,
}
